import { OiamEvents } from '@oiambk/oiam-oauth-types';
import { Component } from '@stencil/core';
import log from 'loglevel';
import { EventActionDispatcher } from '../../npmlib/services/event-action-dispatcher';
import { EventQueue } from '../../npmlib/services/event-queue';
import { FeatureToggle } from '../../npmlib/services/feature-toggle';
import { fetchDefaultConfig } from '../../npmlib/services/fetch-default-config';
import { NginxErrorLogger } from '../../npmlib/services/nginx-error-logger';
import { OauthEventService } from '../../npmlib/services/oauth-event-service';
import { OauthService } from '../../npmlib/services/oauth-service';
import { StoreService } from '../../npmlib/services/store-service';

@Component({
  tag: 'oiam-oauth-component',
  shadow: true,
})
export class OiamOauthComponent {
  private eventQueue: EventQueue;
  async componentWillLoad() {
    log.debug('oiam-oauth-wc: will-load');
    /*
    create instance
    there can only be one instance running if the component is available multiple times
     */
    if (!StoreService.createInstance()) {
      // never resolving promise to prevent multiple instances of oiam-oauth-wc
      return new Promise(() => {});
    }
    // oiam-oauth-fallback component is sometimes loaded, despite the real oiam-oauth-component (e.g. old version of fallback)
    // remove fallback component to definitely prevent it from loading
    this.removeFallbackComponent();

    const defaultConfig = await fetchDefaultConfig();
    NginxErrorLogger.setLogUrl();
    FeatureToggle.init(defaultConfig);
    await OauthService.init(defaultConfig);
    this.eventQueue = new EventQueue(new EventActionDispatcher());
    return true;
  }

  render() {
    return '';
  }

  componentDidLoad() {
    log.debug('oiam-oauth-wc did-render: register events');
    window.self.addEventListener(OiamEvents.DOLOGIN, e => this.eventQueue.push(e as CustomEvent));
    window.self.addEventListener(OiamEvents.SETCONFIG, e => this.eventQueue.push(e as CustomEvent));
    window.self.addEventListener(OiamEvents.DOLOGOUT, e => this.eventQueue.push(e as CustomEvent));
    window.self.addEventListener(OiamEvents.SENDTOKEN, e => this.eventQueue.push(e as CustomEvent));
    window.self.addEventListener(OiamEvents.SENDSESSION, e => this.eventQueue.push(e as CustomEvent));
    document.addEventListener('visibilitychange', () => this.doStateActionsIfVisible());

    // handle loading from back-forward-cache
    window.addEventListener('pageshow', async event => {
      if (event.persisted) {
        // validate the correct state
        await this.eventQueue.push(new CustomEvent('loadedFromCache'));
      }
    });

    // loaded
    OauthEventService.doDispatchEvent(OiamEvents.LOADED, true);
  }

  private async doStateActionsIfVisible() {
    // render component anew
    if (document.visibilityState === 'visible') {
      await this.eventQueue.push(new CustomEvent('oiamHasBecomeVisible'));
    }
  }

  private removeFallbackComponent() {
    const els = document.getElementsByTagName('oiam-oauth-fallback');
    if (els.length > 0) {
      // fallback checks 2s for oiamLoadedEvent of the hosted component in the componentWillLoad method
      // only if the event is not present old versions of the fallback will render (new ones have an additional check for the hosted component)
      // if the fallback really is rendered, we should not remove it any more
      // only remove if not already fully rendered (class != hydrated)
      const attrClass = els.item(0).getAttribute('class');
      if (!attrClass || !attrClass.includes('hydrated')) {
        const parent = els.item(0).parentElement;
        parent?.removeChild(els.item(0));
      }
    }
  }
}
